import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const MyProfileTagManagementStyled = styled.div`
  .containerHeader {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    /* Sin padding propio: el de la página (30px 60px) es el mismo que en candidatos y favoritos */
    padding: 0;
    gap: 50px;
  }

  .sectionSecond {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 15px;

    & h2 {
      font-size: 20px; /* título de página de Velora, igual que candidatos y favoritos */
      font-weight: 600;
      line-height: 1.2;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
    & h5 {
      font-size: 14px;
      font-weight: 400;
      color: ${tokens.color.text.tertiary};
      line-height: inherit;
    }

    & p {
      font-weight: 400;
      color: #7a808d;
    }
  }

  .autocomplete-custom {
    width: 240px;
  }

  .MuiTableHead-root th {
    text-align: left !important;
  }

  .headerTable {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }

  /* Buscador y filtro de módulo en su propia fila, a la izquierda, como en Usuarios */
  .tags-header {
    .tags-filters {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }
  }

  .MuiTableCell-root {
    font-family: 'Poppins';
  }

  .color-picker-button {
    border: none;
    border-radius: 8px;
    width: 30px;
    height: 30px;
    padding: 10px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
`

export default MyProfileTagManagementStyled
